import en from "@/lang/en";

export default { en };
